// ═══════════════════════════════════════════════════════════════════════════
// FARM-BOOKING - PALETTE GRAFCET
// ═══════════════════════════════════════════════════════════════════════════
// frontend/src/modules/grafcet/components/GrafcetPalette.jsx
// Palette de blocs draggables pour l'éditeur GRAFCET
// Papy 73+ - Joshua approved! 🚀
// ═══════════════════════════════════════════════════════════════════════════

import React from 'react';
import '../styles/GrafcetPalette.css';

// ═══════════════════════════════════════════════════════════════════════════
// DÉFINITION DES BLOCS
// ═══════════════════════════════════════════════════════════════════════════

const BLOC_CATEGORIES = [
  {
    name: 'Capteurs & Mesures',
    icon: '📊',
    blocs: [
      {
        type: 'lecture_capteur',
        label: 'Lecture Capteur',
        icon: '📊',
        description: 'Lire la valeur d\'un capteur',
        color: '#3b82f6'
      }
    ]
  },
  {
    name: 'Logique',
    icon: '🧠',
    blocs: [
      {
        type: 'condition',
        label: 'Condition',
        icon: '❓',
        description: 'Tester une condition (SI...)',
        color: '#f59e0b'
      },
      {
        type: 'boucle',
        label: 'Boucle',
        icon: '🔄',
        description: 'Répéter N fois',
        color: '#8b5cf6'
      }
    ]
  },
  {
    name: 'Actions',
    icon: '⚡',
    blocs: [
      {
        type: 'action_simple',
        label: 'Action',
        icon: '⚡',
        description: 'Commander un actionneur',
        color: '#6366f1'
      },
      {
        type: 'timer',
        label: 'Timer',
        icon: '⏱️',
        description: 'Attendre une durée',
        color: '#f97316'
      },
      {
        type: 'notification',
        label: 'Notification',
        icon: '🔔',
        description: 'Envoyer une alerte',
        color: '#ec4899'
      }
    ]
  },
  {
    name: 'Intelligence',
    icon: '🤖',
    blocs: [
      {
        type: 'ia_conseil',
        label: 'Conseil IA',
        icon: '🤖',
        description: 'Demander un conseil à l\'IA',
        color: '#06b6d4'
      },
      {
        type: 'attente_validation',
        label: 'Validation',
        icon: '✋',
        description: 'Attendre validation humaine',
        color: '#22c55e'
      }
    ]
  },
  {
    name: 'Parallélisme',
    icon: '⫽',
    blocs: [
      {
        type: 'parallele_debut',
        label: 'Début //',
        icon: '⫽',
        description: 'Démarrer branches parallèles',
        color: '#64748b'
      },
      {
        type: 'parallele_fin',
        label: 'Fin //',
        icon: '⫽',
        description: 'Rejoindre branches parallèles',
        color: '#64748b'
      }
    ]
  }
];

// ═══════════════════════════════════════════════════════════════════════════
// COMPOSANT BLOC DRAGGABLE
// ═══════════════════════════════════════════════════════════════════════════

const DraggableBloc = ({ bloc }) => {
  const onDragStart = (event) => {
    event.dataTransfer.setData('application/grafcet-node', bloc.type);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      className="grafcet-palette__bloc"
      draggable
      onDragStart={onDragStart}
      style={{ '--bloc-color': bloc.color }}
      title={bloc.description}
    >
      <span className="grafcet-palette__bloc-icon">{bloc.icon}</span>
      <span className="grafcet-palette__bloc-label">{bloc.label}</span>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════════════
// COMPOSANT PRINCIPAL
// ═══════════════════════════════════════════════════════════════════════════

export default function GrafcetPalette() {
  return (
    <div className="grafcet-palette">
      <div className="grafcet-palette__header">
        <h3 className="grafcet-palette__title">
          <span className="grafcet-palette__title-icon">🧰</span>
          Blocs
        </h3>
        <p className="grafcet-palette__hint">Glissez sur le canvas</p>
      </div>
      
      <div className="grafcet-palette__content">
        {BLOC_CATEGORIES.map((category) => (
          <div key={category.name} className="grafcet-palette__category">
            <div className="grafcet-palette__category-header">
              <span className="grafcet-palette__category-icon">{category.icon}</span>
              <span className="grafcet-palette__category-name">{category.name}</span>
            </div>
            <div className="grafcet-palette__blocs">
              {category.blocs.map((bloc) => (
                <DraggableBloc key={bloc.type} bloc={bloc} />
              ))}
            </div>
          </div>
        ))}
      </div>
      
      <div className="grafcet-palette__footer">
        <div className="grafcet-palette__legend">
          <div className="grafcet-palette__legend-item">
            <span className="grafcet-palette__legend-dot grafcet-palette__legend-dot--debut"></span>
            <span>Début (auto)</span>
          </div>
          <div className="grafcet-palette__legend-item">
            <span className="grafcet-palette__legend-dot grafcet-palette__legend-dot--fin"></span>
            <span>Fin (auto)</span>
          </div>
        </div>
      </div>
    </div>
  );
}
